"use strict";

var _defineProperty = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlag = exports.setFlag = exports.LOCAL_STORAGE_FLAG_KEY = void 0;
exports.LOCAL_STORAGE_FLAG_KEY = 'feature-web-flags';

var saveContents = function saveContents() {
  var contents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  localStorage.setItem(exports.LOCAL_STORAGE_FLAG_KEY, window.btoa(JSON.stringify(contents)));
};

var readContents = function readContents() {
  var value = localStorage.getItem(exports.LOCAL_STORAGE_FLAG_KEY);
  return value ? JSON.parse(window.atob(value)) : {};
};

var setFlag = function setFlag(flag, value) {
  saveContents(Object.assign(Object.assign({}, readContents()), _defineProperty({}, flag, value)));
};

exports.setFlag = setFlag;

var getFlag = function getFlag(flag) {
  return readContents()[flag];
};

exports.getFlag = getFlag;